import registry from './registry.v1.json';

const BG_VAR = {
  transport: '--icon-bg-transport',
  food: '--icon-bg-food',
  safe: '--icon-bg-safe',
  shopping: '--icon-bg-shopping',
  travel: '--icon-bg-travel',
  living: '--icon-bg-living',
  health: '--icon-bg-health',
  education: '--icon-bg-education',
  finance: '--icon-bg-finance',
  jobs: '--icon-bg-jobs',
  pet: '--icon-bg-pet',
  event: '--icon-bg-event',
  media: '--icon-bg-media',
  care: '--icon-bg-care',
  neutral: '--icon-bg-neutral',
};

const SIZE_PX = { xs: 16, sm: 24, md: 32, lg: 40 };

let warnedKeys = new Set();

function warnUnknown(iconKey, context) {
  if (warnedKeys.has(iconKey)) return;
  warnedKeys.add(iconKey);
  if (process.env.NODE_ENV === 'production') return;
  // eslint-disable-next-line no-console
  console.warn('[MingoIcon] unknown icon_key', { iconKey, context });
}

export function resolveIcon(iconKey, variant = 'squircle', options = {}) {
  const entry = registry.icons[iconKey] || registry.icons.unknown;
  if (!registry.icons[iconKey]) warnUnknown(iconKey, options.context);

  const v = entry.variants[variant] || entry.variants.squircle || entry.variants.line;
  const bgToken = options.bgToken || v?.defaultBgToken || entry.category || 'neutral';
  const bgVar = BG_VAR[bgToken] || BG_VAR.neutral;
  const tabler = v?.tabler || entry.tabler || null;

  return {
    paths: v?.paths || [],
    tabler,
    bgVar,
    bgToken,
    iconBg: entry.iconBg || v?.iconBg || null,
    iconColor: entry.iconColor || v?.iconColor || null,
    useGradient: variant === 'squircle' && options.active && !entry.iconBg,
    sizePx: SIZE_PX[options.size] || SIZE_PX.md,
  };
}

export { registry };
